import { getProfessionalCampaigns } from './GetProfessionalCampaigns';
import { getCampaigns } from './GetCampaigns';
import { getCampaign } from './GetCampaign';
import { getCampaignReport } from './GetCampaignReport';
import { getCampaignTargetOffices } from './GetCampaignTargetOffices';
import { getOfficeDiscountHistory } from './GetOfficeDiscountHistory';
import { applyOfficePromoCode } from './ApplyOfficePromoCode';
import { removeOfficePromoCode } from './RemoveOfficePromoCode';

export const CampaignsApi = {
  getProfessionalCampaigns,
  getCampaigns,
  getCampaign,
  getCampaignReport,
  getCampaignTargetOffices,
  getOfficeDiscountHistory,
  applyOfficePromoCode,
  removeOfficePromoCode,
};

export { CAMPAIGNS_ENDPOINT, CAMPAIGNS_MAX_LIMIT } from './GetCampaigns';
